import React from 'react';
import PropTypes from 'prop-types';
import styles from './Modal.styl';
import Title from '../title/Title';
import WhiteX from '-!svg-react-loader!../../assets/X_Wrong_White.svg';
/* eslint import/no-webpack-loader-syntax: off */

const Modal = props => {
  return (
    <div className={styles.background}>
      <div className={styles.closeModal} onClick={props.closeModal}>
        <WhiteX width={30} height={30} />
      </div>
      <div className={styles.innerModal} id="inner-modal">
        <Title
          contactType={props.contactType}
          zip={props.zip}
        />
        {props.children}
      </div>
    </div>
  );
};

Modal.propTypes = {
  children: PropTypes.array
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/modal/Modal.js